import React, { useState, useRef, useEffect } from "react";
import { NavLink, useNavigate, useLocation, matchPath } from "react-router-dom";
import '../../App.css';
import { HiMenu } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useCustomContext } from "../../UIElements/CustomComponents/CustomComponents";
import { FaHome } from "react-icons/fa";
import { FaUserGroup } from "react-icons/fa6";
import { IoMdNotifications } from "react-icons/io";
import { CgDetailsMore } from "react-icons/cg";
import './Navbar.css';
import { insertLog } from "../Logs/InsertLog";
import { LuLogs } from "react-icons/lu";

const Navbar = ({ username, onSignout }) => {
  const [expanded, setExpanded] = useState(true);
  const [isIconsOnly, setIsIconsOnly] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const folderMatch = matchPath('/details', location.pathname);
  const { showAlert, stopHudRotation, hud } = useCustomContext();
  const handleMenu = () => {
    setIsIconsOnly((prev) => !prev);
  };
  const accessLevel = parseInt(localStorage.getItem('accessLevel'), 10);
  const UserStatus = localStorage.getItem("UserStatus");
  const useremail = localStorage.getItem("email");
  const userName = useremail?.split('@')[0];
  // Check if current path matches the folder route

  const Logout = () => {
    // Keys to keep
    const keysToKeep = ['rememberMe', 'rememberedEmail', 'rememberedPassword'];

    showAlert('Are you sure you want to logout?', [
      {
        label: 'Yes',
        onClick: async () => {
          Object.keys(localStorage).forEach((key) => {
            if (!keysToKeep.includes(key)) {
              localStorage.removeItem(key);
            }
          });

          try {
            await insertLog(
              `${userName} successfully logged out`,
              0,
              useremail,
              hud,
              stopHudRotation,
          
            );

            onSignout();     // Call sign out after logging is done
            navigate('/');   // Redirect after signout
          } catch (error) {
            console.error('Failed to insert logout log:', error);
            showAlert('Logout log failed. Still signing out for safety.', [
              { label: 'Ok', color: 'var(--buttonColor)' }
            ]);
            onSignout();
            navigate('/');
          }
        },
        color: 'var(--buttonColor)', // Set button color
      },
      {
        label: 'No',
        onClick: () => {
          // console.log('User cancelled logout');
        },
        color: 'gray', // Set button color
      }
    ]);

  };


  return (
    <>
      <div className={`sidebar ${isIconsOnly ? 'icons-only' : ''}`}>
        <div className='headingandhamburger'>
          {!isIconsOnly && <span className='organizationname'>Referral Manager</span>}
          <span className='hamburger' onClick={handleMenu}><HiMenu size={27} /></span>
        </div>
        <ul className='navbar-list'>
          <li className='navbar-list-item'>
            <NavLink to="/Referrals" className="menu">
              <FaHome className="icon" size={17} /> {!isIconsOnly && <span className='menu-text'>Referrals</span>}
            </NavLink>
          </li>
          {folderMatch && (
            <li className='navbar-list-item'>
              <NavLink to="/details" className="menu" style={{ marginLeft: '20px' }}>
                <CgDetailsMore className="icon" /> {!isIconsOnly && <span className='menu-text'>Details</span>}
              </NavLink>
            </li>
          )}

          {accessLevel == 3 &&
            (
              <li className='navbar-list-item'>
                <NavLink
                  to="/Users"
                  className="menu" >
                  <FaUserGroup className="icon" />{!isIconsOnly && <span className='menu-text'>Users</span>}
                </NavLink>
              </li>
            )}
          {(accessLevel === 2 || accessLevel === 3) && (
            <li className='navbar-list-item'>
              <NavLink
                to="/Logs"
                className="menu" >
                <LuLogs className="icon" />{!isIconsOnly && <span className='menu-text'>Logs</span>}
              </NavLink>
            </li>
          )}

          <li className='navbar-list-item'>

            {(UserStatus !== 'EXTERNAL_PROVIDER') &&
              <NavLink
                className="menu"
                to="/Settings"
              >
                <IoMdSettings className="icon" />{!isIconsOnly && <span className='menu-text'>Settings</span>}
              </NavLink>
            }

          </li>
        </ul>
      </div >
      <div className={`display-text ${isIconsOnly ? "icons-only" : ""}`}>

        <div className="position-fixed" style={{ top: 0, right: 0, padding: '10px' }}>
          <button
            className="btn logout-btn d-flex align-items-center"
            onClick={Logout}
            style={{ cursor: 'pointer' }}
          >
            <RiLogoutCircleRLine style={{ fontSize: '24px' }} />
            <span className="ms-2" style={{ fontSize: '18px' }}>Logout</span>
          </button>
        </div>
      </div>
    </>
  );
}

export default Navbar;
